// extracted by mini-css-extract-plugin
export default {"shell":"AdminCenterShell_shell__XPdqR","body":"AdminCenterShell_body__BLnHO","content":"AdminCenterShell_content__jzufD"};